import { useContext } from 'react'
import { DateRangeContext } from 'ui/contexts/DateRangeContext'
import { formatBubbleChartData } from '../../helpers'
import { colors } from 'theme/colors'
import BubbleChart from 'ui/baseComponents/Charts/BubbleChart'
import { useReportTranslation } from 'utilities/i18n'

const ReportChartMedication = ({ eventList: loggedMeds }) => {
  const { t } = useReportTranslation()
  const { selectedTimezone } = useContext(DateRangeContext)
  const title = t('report.medication.chartLoggedMedication')

  const legendItem = {
    name: title,
    color: colors.PRIMARY[1000],
  }

  const data = formatBubbleChartData({
    label: title,
    data: loggedMeds,
    selectedTimezone,
  })

  return (
    <BubbleChart
      {...{
        title,
        data,
        legendItem,
        legend: true,
        height: 60,
        animateBubbles: false,
        chartId: 'medication-chart',
      }}
    />
  )
}

export default ReportChartMedication
